import React from "react";
import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import CONFIG from "../../../../utils/config";
import { isCurrentTickerStepDisable } from "../../../../utils/functions";

function StepButton({
  scheduleData,
  currentStep,
  isStepLoading,
  prev,
  next,
  sendNow,
  handleCancel,
}) {
  const {
    LABELS: {
      NOTIFICATIONS: { PREV, NEXT, CANCEL, SAVE, SEND_NOW, SCHEDULE },
    },
  } = CONFIG;

  const disabledObj = isCurrentTickerStepDisable(currentStep, scheduleData);

  return (
    <div className="footer-btns">
      {currentStep !== 0 && (
        <Button className="primary-outline" onClick={() => prev()}>
          {PREV}
        </Button>
      )}
      <Button
        className="primary-solid position-relative"
        onClick={() => next()}
        disabled={disabledObj.next || disabledObj.save || isStepLoading}
      >
        {currentStep === 1 ? SCHEDULE : currentStep === 2 ? SAVE : NEXT}
        {isStepLoading && <LoadingOutlined className="loading" />}
      </Button>
      {currentStep === 1 && (
        <Button
          className="primary-solid"
          onClick={sendNow}
          disabled={disabledObj.sendNow}
        >
          {SEND_NOW}
        </Button>
      )}
      {currentStep === 0 && (
        <Button
          className="primary-outline"
          onClick={() => handleCancel()}
          disabled={isStepLoading}
        >
          {CANCEL}
        </Button>
      )}
    </div>
  );
}

export default StepButton;
